import React, { forwardRef, useEffect, useState } from 'react';
import { Separate } from "../../../utils/separate";
import clsx from 'clsx';

export const Textarea = forwardRef<HTMLTextAreaElement, React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> & { label: string, error?: boolean, errorText?: string }>(({ label, className, error, errorText, ...props }, ref) => {
    // const [value, setValue] = useState(null)
    // const handleChange = (e) => {
    //     setValue(e.target.value.replaceAll(",", ""))
    //     onchange({ name: name, value: e.target.value.replaceAll(",", "") })
    // }
    // useEffect(() => {
    //     setValue(defaultValue || "")
    // }, [defaultValue])

    return (
        <div className='flex flex-col gap-2 flex-1'>

            <div className={`relative w-full ${className} ${props?.disabled && "pointer-events-none opacity-40 flex-1 w-full"}`}>
                <textarea
                    className={clsx(
                        `peer block px-2.5 pb-2.5 pt-4 w-full flex-1 text-xs md:text-sm text-gray-900 bg-transparent rounded-lg border-[1px]  appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-main peer`,
                        error ? 'border-red' : 'border-gray-300'
                    )}
                    placeholder={props.placeholder ?? ''}
                    ref={ref}
                    {...props}
                />
                <label
                    className={clsx(`absolute pointer-events-none     max-w-[95%]   text-xs md:text -sm peer-empty:text-sm  placeholder-shown:text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4  top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2    peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:text-[10px] peer-focus:-translate-y-4   start-1` , error ? 'text-red' : ' peer-empty:text-gray-500   text-main peer-focus:dark:text-blue-500 peer-focus:text-main')}>
                    {label}
                </label>

            </div>
            {/* {!!error && !!errorText && <span className='text-red text-xs mt-1'>{errorText}</span>} */}
        </div>
    )
})


